import { z } from 'zod';
/**
 * Public Sitemap REST DTO — Phase 7 / Plan 07-05 (HUB-02 확장).
 *
 * 엔드포인트 (공개 — SessionMiddleware `.exclude('api/v1/public/*splat')`):
 *   - `GET /api/v1/public/sitemap/streamers` — sitemap.xml 생성용 slug 리스트.
 *
 * 사용처:
 *   - `apps/web/src/app/sitemap.ts` — Next.js MetadataRoute.Sitemap generator 가
 *     본 endpoint 로 upstream fetch → `/s/{slug}` + `/@{slug}` 두 URL 엔트리 생성.
 *
 * 불변 (07-05-PLAN Task 1 <behavior>):
 *   - 최대 10,000 개 slug — sitemap 표준 limit 50,000 URL / 50MB 의 안전 여유.
 *     (1 streamer = 2 URL 이므로 20,000 URL 이내.)
 *   - `tossSellerStatus != 'NOT_SUBMITTED'` 필터 — 미인증 streamer 는 공개 sitemap 에서 제외.
 *     (T-07-05-01 Information Disclosure 완화 — 심사 미통과 계정을 검색 엔진에 노출하지 않음.)
 *   - `updatedAt DESC` 정렬 — 최근 갱신된 streamer 를 상위 배치.
 *
 * 응답 shape:
 *   - items[i].slug — `channelSlug` (정규식 `/^[a-zA-Z0-9_-]{1,64}$/`).
 *   - items[i].updatedAt — ISO 8601 with offset (MetadataRoute.Sitemap 의 `lastModified` 필드 원본).
 *   - fetchedAt — 서버 snapshot 시각 (ISR 히트 여부 관측 참고).
 */
/**
 * sitemap 엔트리 1건 (1 streamer = 2 URL 생성의 원천).
 */
export const publicSitemapStreamerItemSchema = z.object({
    /** 공개 식별자. `/s/{slug}` · `/@{slug}` URL path 에 직접 들어감. */
    slug: z
        .string()
        .min(1)
        .max(64)
        .regex(/^[a-zA-Z0-9_-]+$/),
    /** 최근 갱신 시각 — sitemap lastModified 필드의 원본. */
    updatedAt: z.string().datetime({ offset: true }),
});
/**
 * GET /api/v1/public/sitemap/streamers 응답.
 *
 * Next.js Route Handler 없이 sitemap.ts 가 직접 upstream fetch.
 * (랜딩·streamer 조회와 달리 sitemap 은 고정 TTL 300s — 별도 route handler 불필요.)
 */
export const publicSitemapStreamersResponseSchema = z.object({
    items: z.array(publicSitemapStreamerItemSchema).max(10_000),
    fetchedAt: z.string().datetime({ offset: true }),
});
//# sourceMappingURL=public-sitemap.rest.js.map